import React from 'react'
import classNames from 'classnames'

function Box({ children, modifierClasses = [] }) {
  const containerClasses = classNames(
    'box',
    modifierClasses
  )
  return (
    <div className={containerClasses}>
      {children}
    </div>
  )
}

export default Box
